import { GameType } from '../model/enumeration/GameType.enum';

export interface Properties {
  holesLength: number;
  tableColor: string;
  tableImage: string;
}

const NLH_COLOR = 'var(--clubgg-green)';
const NLHS_COLOR = '#c02413';
const MTT_COLOR = '#d87c09';
const SNG_COLOR = '#b08e27';
const PLO_COLOR = '#0f4b94';
const PLO5_COLOR = '#047aa2';
const PLO6_COLOR = '#0a7466';

const NLH_TABLE_IMAGE = '/assets/table-nlh-clubgg.png';
const NLHS_TABLE_IMAGE = '/assets/table-nlhs-clubgg.png';
const MTT_TABLE_IMAGE = '/assets/table-mtt-clubgg.png';
const SNG_TABLE_IMAGE = '/assets/table-sng-clubgg.png';
const PLO_TABLE_IMAGE = '/assets/table-plo-clubgg.png';
const PLO5_TABLE_IMAGE = '/assets/table-plo5-clubgg.png';
const PLO6_TABLE_IMAGE = '/assets/table-plo6-clubgg.png';

const gameTypes = new Map<GameType, Properties>([
  [
    GameType.NLH,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLH31,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHB,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLR,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLP,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHS,
    {
      holesLength: 2,
      tableColor: NLHS_COLOR,
      tableImage: NLHS_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHSB,
    {
      holesLength: 2,
      tableColor: NLHS_COLOR,
      tableImage: NLHS_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHDB,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHBDB,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.MTT,
    {
      holesLength: 2,
      tableColor: MTT_COLOR,
      tableImage: MTT_TABLE_IMAGE,
    },
  ],
  [
    GameType.MTTPLO,
    {
      holesLength: 4,
      tableColor: MTT_COLOR,
      tableImage: MTT_TABLE_IMAGE,
    },
  ],
  [
    GameType.MTTPLO5,
    {
      holesLength: 5,
      tableColor: MTT_COLOR,
      tableImage: MTT_TABLE_IMAGE,
    },
  ],
  [
    GameType.SNG,
    {
      holesLength: 2,
      tableColor: SNG_COLOR,
      tableImage: SNG_TABLE_IMAGE,
    },
  ],
  [
    GameType.SPN,
    {
      holesLength: 2,
      tableColor: SNG_COLOR,
      tableImage: SNG_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHSQ,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLHSU,
    {
      holesLength: 2,
      tableColor: NLH_COLOR,
      tableImage: NLH_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLODB,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLOBDB,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLOB,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLR,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLOSQ,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLO,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLOB,
    {
      holesLength: 4,
      tableColor: PLO_COLOR,
      tableImage: PLO_TABLE_IMAGE,
    },
  ],
  [
    GameType.NLO5,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO5,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO5B,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO5DB,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO5BDB,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLR5,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO5SQ,
    {
      holesLength: 5,
      tableColor: PLO5_COLOR,
      tableImage: PLO5_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO6,
    {
      holesLength: 6,
      tableColor: PLO6_COLOR,
      tableImage: PLO6_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO6B,
    {
      holesLength: 6,
      tableColor: PLO6_COLOR,
      tableImage: PLO6_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO6BDB,
    {
      holesLength: 6,
      tableColor: PLO6_COLOR,
      tableImage: PLO6_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO6DB,
    {
      holesLength: 6,
      tableColor: PLO6_COLOR,
      tableImage: PLO6_TABLE_IMAGE,
    },
  ],
  [
    GameType.PLO6SQ,
    {
      holesLength: 6,
      tableColor: PLO6_COLOR,
      tableImage: PLO6_TABLE_IMAGE,
    },
  ],
]);

export const getHolesLength = (gameType: GameType): number =>
  gameTypes.get(gameType)?.holesLength || 0;

export const getTableColor = (gameType: GameType): string =>
  gameTypes.get(gameType)?.tableColor || NLH_COLOR;

export const getTableImage = (gameType: GameType): string =>
  gameTypes.get(gameType).tableImage || NLHS_TABLE_IMAGE;
